module.exports = __webpack_public_path__ + "img/title-1.a46d7e36.png";